import { Card, CardContent, Spinner } from '@crm/ui';
import { Megaphone } from 'lucide-react';
import { PageHeader } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { useCan } from '@/modules/auth/hooks';
import { useAutomations, useTestAutomation, useUpdateAutomation } from '../api';
import { AutomationCard } from '../components/automation-card';

/**
 * Os avisos que o WhatsApp manda sozinho quando um horario e marcado ou
 * desmarcado - nascem do agendamento, e nao de um publico escolhido, por
 * isso ficam fora de Campanhas.
 */
export function AutomationsPage() {
  useDocumentTitle('Mensagens automaticas');

  const canWrite = useCan('settings', 'WRITE');
  const automations = useAutomations();
  const updateAutomation = useUpdateAutomation();
  const testAutomation = useTestAutomation();

  return (
    <div className="space-y-4">
      <PageHeader
        icon={<Megaphone />}
        title="Mensagens automaticas"
        description="Avisos que saem sozinhos quando um horario e marcado, lembrado ou cancelado."
      />

      <Card variant="flush">
        <CardContent className="space-y-4 py-4">
          {automations.isPending ? (
            <div className="flex justify-center py-8">
              <Spinner className="h-6 w-6 text-muted-foreground" />
            </div>
          ) : (
            automations.data?.data.map((automation) => (
              <AutomationCard
                key={automation.type}
                automation={automation}
                readOnly={!canWrite}
                saving={
                  updateAutomation.isPending && updateAutomation.variables?.type === automation.type
                }
                testing={testAutomation.isPending && testAutomation.variables === automation.type}
                onSave={(input) => updateAutomation.mutate({ type: automation.type, input })}
                onTest={() => testAutomation.mutate(automation.type)}
              />
            ))
          )}

          {testAutomation.data ? (
            <p className="text-sm text-muted-foreground">
              Teste enviado para {testAutomation.data.to}.
            </p>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}
